import { OnlyViewHoc } from 'hocs'

import { useStores } from 'hooks/useStores'
import { logisticCartApi } from 'redux/services/logistic-cart'

import { AppLoader } from 'components/AppLoader'
import { AppModalHeader } from 'components/AppModal/AppModalHeader'

import { LogisticCart, LogisticCartStatus } from 'models/logistic_cart'
import { UserRole } from 'models/user'

import { LabledInfo, StatusHistory } from 'shared/ui'

import styles from './Details.module.scss'
import { EditLogisticModal } from './Edit'
import { UpdateStatus } from './UpdateStatus'

interface DetailsProps {
  id: LogisticCart['id']
  onClose: () => void
}

export const Details = ({ id, onClose }: DetailsProps) => {
  const { userStore } = useStores()
  const role = userStore.user?.role as UserRole
  const { data, isLoading, isSuccess, error } =
    logisticCartApi.useGetLogisticCartByIdQuery(id)

  if (isLoading) return <AppLoader />

  if (isSuccess && data) {
    return (
      <>
        <AppModalHeader onClose={onClose} title={`№${id}`} />
        <div className={styles.container}>
          <LabledInfo label="ФИО клиента">{data.client_full_name}</LabledInfo>
          <LabledInfo label="Пан">{data.pan}</LabledInfo>
          <LabledInfo label="Комментарий">{data.comment || '-'}</LabledInfo>
          <LabledInfo label="Дата создания">{data.created_at}</LabledInfo>
          <LabledInfo label="Дата эмбоссирования">
            {data.date_embossment}
          </LabledInfo>
          <LabledInfo label="Степень срочности">
            {data.degree_urgency_title}
          </LabledInfo>
          <LabledInfo label="Номер телефона">{data.phone || '-'}</LabledInfo>
          <LabledInfo label="Статус">{data.status_title}</LabledInfo>
          <LabledInfo label="Пан">{data.pan}</LabledInfo>
          {data.specialist && (
            <LabledInfo label="Специалист">
              {data.specialist.full_name} {data.specialist.phone}
            </LabledInfo>
          )}

          <StatusHistory list={data.status_list} />

          <OnlyViewHoc>
            {data ? (
              <>
                {[
                  LogisticCartStatus.waiting,
                  LogisticCartStatus.error,
                ].includes(data.status) &&
                  [UserRole.Specialist].includes(role) && (
                    <EditLogisticModal key={data.id} data={data} />
                  )}
                {data.status === LogisticCartStatus.waiting &&
                  role === UserRole.ControllerUKC && (
                    <>
                      <UpdateStatus
                        status={LogisticCartStatus.denied}
                        id={id}
                      />
                      <UpdateStatus status={LogisticCartStatus.error} id={id} />
                      <UpdateStatus
                        status={LogisticCartStatus.in_process}
                        id={id}
                      />
                    </>
                  )}
                {data.status === LogisticCartStatus.in_process &&
                  role === UserRole.ControllerUKC && (
                    <UpdateStatus status={LogisticCartStatus.given} id={id} />
                  )}
              </>
            ) : null}
          </OnlyViewHoc>
        </div>
      </>
    )
  }

  return <code>{JSON.stringify(error)}</code>
}
